import { api } from './client'

export interface DeskSSOLink {
    url: string
}

// getDeskSSOLink mints a Desk portal redirect URL for the given ticket
// reference (server-validated format `^[A-Z]{2,8}-\d{4}-\d{4,}$`). Throws
// ApiError with code DESK_SSO_DISABLED (feature not configured) or
// DESK_SSO_INVALID_REF (bad ref) — see api-error-messages.ts.
export const deskSsoApi = {
    getLink: (ref: string) =>
        api.get<DeskSSOLink>('/support/desk-sso', { params: { ref } }),
}
